module.exports = __webpack_public_path__ + "img/arrow.b0098824.svg";